var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.selectedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }